<template>
  <div class="dialog-child">
    <el-tabs v-model="activeName" stretch class="tabs-2" @tab-click="tabClick">
      <el-tab-pane label="基础信息" name="tab1"></el-tab-pane>
      <el-tab-pane label="法律状态" name="tab2"></el-tab-pane>
      <el-tab-pane label="权利要求" name="tab3"></el-tab-pane>
      <el-tab-pane label="说明书" name="tab4"></el-tab-pane>
      <el-tab-pane label="附图" name="tab5"></el-tab-pane>
    </el-tabs>
    <div style="height: 660px;overflow: auto;padding: 0px 20px 50px;" class="dialogs">
      <div class="small-title" ref="small1" style="padding-top: 10px;">基本信息</div>
      <el-descriptions :column="1" border>
        <el-descriptions-item>
          <template slot="label">发明名称</template>
          {{ patentDetail.name || '-' }}
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="2" border>
        <el-descriptions-item>
          <template slot="label">申请号</template>
          {{ patentDetail.applicationNumber || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请日期</template>
          {{ patentDetail.filingDate || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">公开(公告)号</template>
          {{ patentDetail.publicNumber || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">公开(公告)日</template>
          {{ patentDetail.openDay || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">优先权号</template>
          {{ patentDetail.priorityNumber || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">优先权日</template>
          {{ patentDetail.priorityDay || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">IPC分类号</template>
          {{ patentDetail.classificationNumber || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">CPC分类号</template>
          -
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">专利类型</template>
          {{ patentDetail.classification || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">法律状态</template>
          <span v-if="patentDetail.legalStatus">{{ patentDetail.legalStatus.legalStatus || '-' }}</span>
          <span v-else>-</span>
        </el-descriptions-item>
      </el-descriptions>
      <div class="small-title">申请/代理机构</div>
      <el-descriptions :column="2" border>
        <el-descriptions-item>
          <template slot="label">申请(专利权)人</template>
          {{ patentDetail.applicant || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">发明人</template>
          {{ patentDetail.inventor || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请人地址</template>
          {{ patentDetail.address || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请人邮编</template>
          {{ patentDetail.postCode || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">代理机构</template>
          {{ patentDetail.agency || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">代理人</template>
          {{ patentDetail.agent || '-' }}
        </el-descriptions-item>
      </el-descriptions>
      <div class="small-title">摘要</div>
      <el-row>
        <el-col :span="24" class="col-2" style="line-height: 25px;padding: 20px;">
          {{ patentDetail.patentAbstract || '-' }}
        </el-col>
      </el-row>
      <div class="small-title" ref="small2">法律状态</div>
      <el-row>
        <el-col :span="24" class="col-2" style="min-height: 200px;" v-if="patentDetail.legalStatus">
          <el-steps :active="patentDetail.legalStatus.legalIndex" direction="vertical" space="60px">
            <el-step v-for="(activity, index) in patentDetail.legalStatus.activities" :title="activity.timestamp"
                     :description="activity.content"></el-step>
          </el-steps>
        </el-col>
        <el-col :span="24" class="col-2" style="min-height: 200px;" v-else/>
      </el-row>
      <div class="small-title" ref="small3">权利要求</div>
      <el-row>
        <el-col :span="24" class="col-2" style="line-height: 25px;font-size: 14px;color: #333333;padding: 20px;">
          {{ patentDetail.claims || '-' }}
        </el-col>
      </el-row>
      <div class="small-title" ref="small4">说明书</div>
      <el-row>
        <el-col :span="24" class="col-2" style="line-height: 25px;font-size: 14px;color: #333333;padding: 20px;">
          {{ patentDetail.instructions || '-' }}
        </el-col>
      </el-row>
      <div class="small-title" ref="small5">附图</div>
      <el-row>
        <el-col :span="24" class="col-2">
          <div v-if="patentDetail.attachedDrawings">
            <el-image style="width: 200px; height: 200px" :src="patentDetail.attachedDrawings" fit="scale-down"
                      :preview-src-list="[patentDetail.attachedDrawings]"></el-image>
          </div>
          <div v-else>无</div>
        </el-col>
      </el-row>
    </div>
    <el-row style="padding: 20px 20px 20px 0px;">
      <el-button type="primary" style="float: right" @click="seePDF(patentDetail.patentDocuments)">专利文献</el-button>
    </el-row>
    <!--PDF文件预览-->
    <el-dialog title="预览" :visible.sync="dialogPriviewPdf" top="0px" width="100%">
      <div :style="'height:'+dialogHeight+'px;'">
        <iframe style="width: 100%;height: 100%" :src="pdfSrc" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "patentDetails",
  data() {
    return {
      activeName: 'tab1',
      dialogPriviewPdf: false,
      pdfSrc: '',
      dialogHeight: '750',
    }
  },
  props: {
    patentDetail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    tabClick(tab, event) {
      if (tab.name == 'tab1') {
        this.$refs.small1.scrollIntoView({block: 'start', behavior: 'smooth'})
      } else if (tab.name == 'tab2') {
        this.$refs.small2.scrollIntoView({block: 'start', behavior: 'smooth'})
      } else if (tab.name == 'tab3') {
        this.$refs.small3.scrollIntoView({block: 'start', behavior: 'smooth'})
      } else if (tab.name == 'tab4') {
        this.$refs.small4.scrollIntoView({block: 'start', behavior: 'smooth'})
      } else if (tab.name == 'tab5') {
        this.$refs.small5.scrollIntoView({block: 'start', behavior: 'smooth'})
      }
    },
    /*PDF文件预览*/
    seePDF(url) {
      if (url != '' && url != null && url != undefined) {
        this.pdfSrc = url;
        this.dialogPriviewPdf = true;
      } else {
        this.$message({message: '暂无展现数据！', type: 'warning'});
      }
    },
  },
  mounted() {
    this.dialogHeight = parseInt(document.documentElement.clientHeight) - 130;
  }
}
</script>
<style scoped lang="scss">
.dialog-child {
  .dialogs {
    .dialog-tab {
      table-layout: fixed;
      display: contents;
      border-collapse: separate;
      box-sizing: border-box;
      text-indent: initial;
      border-spacing: 2px;
      border-color: grey;
      tr {
        border-spacing: 0px;
      }
      .col-td1 {
        background: #D6E9FF;
        padding: 15px 10px 15px 20px;
        text-align: left;
        color: #333333;
        border: 0.5px solid #E5EEF6;
        width: 15%;
        border-spacing: 0px;
      }
      .col-td2 {
        padding: 15px 10px;
        background: #ffffff;
        text-align: left;
        width: 20%;
        border-spacing: 0px;
        border: 0.5px solid #E5EEF6;
        word-wrap: break-word;
      }
    }
  }
  .dialogs::-webkit-scrollbar {
    width: 8px;
  }
  .dialogs::-webkit-scrollbar-thumb {
    background-color: #DDDDDD;
  }
  .tabs-2 {
    .el-tabs--border-card{
      .el-tabs__header{
        .el-tabs__item {
          transition: all .3s cubic-bezier(.645, .045, .355, 1);
          border: none;
          margin-top: -1px;
          color: #333333;
        }
      }
    }
  }
  .small-title {
    font-size: 16px;
    color: #333333;
    text-align: left;
    padding: 30px 0px 10px;
    font-weight: 500;
  }
  .dialog-fade {
    .el-dialog__body {
      padding: 0px 0px !important;
      border-top: 1px solid #EEEEEE;
    }
  }
  .el-dialog {
    margin: 0 auto 0px;
  }
  .col-7 {
    padding: 15px 10px 15px 20px;
    background: #D6E9FF;
    border: 1px solid #E5EEF6;
    text-align: left;
    color: #333333;
  }
  .col-2 {
    padding: 15px 10px;
    background: #ffffff;
    border: 1px solid #E5EEF6;
    text-align: left;
  }
}
</style>
<style scoped>
.dialog-child >>> .el-tabs__header {
  margin: 0 0 0px;
}
.el-dialog >>> .el-dialog__body {
  padding: 20px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.dialog-child >>> .el-descriptions-item__label.is-bordered-label {
  color: #333333;
  background: #D6E9FF;
  width: 150px;
}
.dialog-child >>> .el-descriptions .is-bordered .el-descriptions-item__cell {
  border: 1px solid #D0E0F2;
  padding: 12px 10px;
  font-size: 14px;
  color: #333333;
  font-weight: 100;
  font-family: 'SourceHanSansCN';
}
.dialog-child >>> .el-descriptions__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.dialog-child >>> .el-descriptions-item__content {
  min-width: 305px;
}
</style>